export const update_design_package = (allow_design_package) => ({
    type: 'UPDATE_ALLOW_DESIGN_PACKAGE',
    allow_design_package,
});
